var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"py-5",attrs:{"type":"flex","justify":"center"}},[_vm._v("\n    Page not found\n")])}
var staticRenderFns = []

export { render, staticRenderFns }